import useData from './data-service'
import type { Memories } from '../types/data-types'

export default function useMemories(): Memories | undefined {
  return useData()?.memories
}
